<template>
    <div>
        <div :class="{ 
            'formeditor__sidebar': $route.params.action === 'graph',
            'row': $route.params.action === 'detail'
        }">
            <div :class="{ 'col-12': $route.params.action === 'detail' }">
                <div v-if="selectedNode && $route.params.action === 'graph'" class="row">
                    <button 
                        class="btn btn-secondary ml-auto"
                        @click="resetNode()"
                    >
                        <b-icon icon="x" width="1em" height="1em" class="ml-2" /> {{ $t('deselect-node') }}
                    </button>
                </div>
                <NodeEditor 
                    v-if="selectedNode" 
                    :node="selectedNode" 
                    :defaultlearningoutcomes="learningoutcomes"
                    :defaultGroups="outcomesGroups"
                    :options="nodeEditorOptions"
                    @nodeChanges="handleNodeEditor" 
                    ref="nodeeditor"
                    :viewOnly="!$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')" 
                />
                <!-- BEGIN LEARNINGOUTCOMES LIST -->
                <div v-if="!selectedNode && $route.params.action === 'graph'">
                    <h3><strong>{{ $t('learning-outcomes') }}</strong></h3>
                    <div>
                        <select class="form-control" v-model="selectedOutcomesGroup">
                            <option :value="{}" selected>{{ $t('select-outcome-group') }}</option>
                            <option v-for="outcomesGroup in outcomesGroups" 
                                :value="outcomesGroup" 
                                :key="outcomesGroup.id"
                                type="text" 
                                class="form-control"
                            >
                                {{ outcomesGroup.title }}
                            </option>
                        </select>
                    </div>
                    <input type="text" v-model="query" class="form-control mt-1 mb-1" :placeholder="$t('search')" />

                    <div class="row d-flex justify-content-end">
                        <CheckboxInput :value="linked_outcomes" @input="linkedToggle()"
                            :label="$t('display-linked-outcomes')" />
                    </div>
                    <div class="list-group mt-1">
                        <div class="list-group-item" v-for="(outcome, key) in displayLearningOutcomes" :key="key"
                            @click="highlightLearningOutcome(outcome.id);"
                            :class="{ active: outcome.id === selectedOutcome }">
                            <template v-if="outcome.code">{{ outcome.code }}: </template>
                            {{ outcome.title }}
                            <div class="float-right" v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">
                                <a class="btn btn-light btn-xs ml-1" style="margin: 0 0 0 0" data-toggle="tooltip"
                                    data-placement="top" :title="$t('go')"
                                    @click.stop="$router.push(`/curriculum-mapping/learning-outcomes/edit/${outcome.id}`)">
                                    <b-icon icon="arrow-bar-right" width="1em" height="1em"></b-icon>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END LEARNINGOUTCOMES LIST -->
            </div>
        </div>
        
        <div :class="{ 'formeditor__mainwindow': $route.params.action === 'graph' }" ref="dendoWrapper" >
            <div class="export-controls" v-if="loaded && $route.params.action === 'graph' && !selectedNode" >
                <!--START DROPDOWN-->
                <b-dropdown
                    id="dropdown-1"
                    :text="$t('download')"
                    class="my-auto ml-2"
                >
                    <b-dropdown-item
                        @click="exportPNG">
                            {{ $t('export-as-png') }}
                        </b-dropdown-item>
                    <b-dropdown-item
                        @click="exportPDF">
                            {{ $t('export-as-pdf') }}
                    </b-dropdown-item>
                </b-dropdown>
                <!--END DROPDOWN-->
            </div>
            <Dendogram v-if="loaded" 
                :hierarchy="hierarchy" 
                @selectedNode="handleSelectedNode" 
                ref="dendogram" 
                :options="dendogramOptions"
                :isGraph="$route.params.action === 'graph'"
            />
            <ActionModal v-else/>
        </div>
        
        <div style="position: fixed; bottom: 0px; left: 50px; right: 300px; z-index: 1000;">
            <NodeDrilldownSearch 
                v-if="loaded && $route.params.action === 'graph'"
                :nodes="nodes"
                @filtered-nodes="handleFilteredNodes"
                :view = "$route.params.action === 'graph' ? 'search' : ''"
                :selectedNode="selectedNode"
            />
        </div>

    </div>
</template>
<script>
import Dendogram from "src/components/CurriculumMapping/Dendogram.vue"
import NodeEditor from "src/components/CurriculumMapping/NodeEditor.vue"
import NodeDrilldownSearch from "src/components/CurriculumMapping/NodeDrilldownSearch.vue";
import CurriculumMap from 'src/modules/curriculummap.js'
import LearningOutcomes from 'src/modules/learningoutcomes.js'
import ActionModal from "../../components/ActionModal.vue";
//import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import 'svg2pdf.js';

export default {
    components: {
        Dendogram,
        NodeEditor,
        NodeDrilldownSearch,
        ActionModal
    },
    data() {
        return {
            learningoutcomes: [],
            hierarchy: {},
            loaded: false,
            root: null,
            selectedNode: null,
            outcomesGroups: null,
            query: '',
            selectedOutcome: null,
            selectedOutcomes: [],
            selectedOutcomesGroup: {},
            linked_outcomes: false,
            nodeEditorOptions: {
                breadcrumbs: this.$route.params.action === 'detail' ? true : false,
                newNodeEditor: true,
                displayChildren: true,
                learningOutcomes: true,
                spareChildrenNodes: true,
                graphView: this.$route.params.action === 'graph' ? true : false,
                nodeLinks: this.$route.params.action === 'graph' ? true : false
            },
            dendogramOptions:{
                    wrapperStyle : {
                        position: this.$route.params.action === 'graph' ? 'fixed' : 'relative', 
                        top: '0', 
                        bottom:'0',
                        left: '50px', 
                        right: this.$route.params.action === 'graph' ? '300px' : '0', 
                        overflow: this.$route.params.action === 'graph' ? 'hidden' : null,
                        display: this.$route.params.action !== 'graph' ? 'flex' : null,
                        alignItems: this.$route.params.action !== 'graph' ? 'center' : null,
                        justifyContent: this.$route.params.action !== 'graph' ? 'center' : null,
                        minHeight: this.$route.params.action !== 'graph' ? '200px' : 'auto',
                        height: 'auto',
                        padding: this.$route.params.action !== 'graph' ? '20px 0' : '0'
                    },
                    chartStyle : {
                        position: this.$route.params.action === 'graph' ? 'absolute' : 'relative',
                        top: this.$route.params.action === 'graph' ? '0' : null,
                        left:' 0',
                        /*width: '100%',
                        height: '100%',*/
                        width: this.$route.params.action === 'graph' ? '100%' : '100%',
                        height: this.$route.params.action === 'graph' ? '100%' : '100%',
                        cursor: this.$route.params.action === 'graph' ? 'move' : 'default',
                        margin: this.$route.params.action === 'graph' ? null : 'auto'
                    },
                    zoomable : this.$route.params.action === 'graph' ? true : false,
                    draggable : this.$route.params.action === 'graph' ? true : false
            },
            nodes: [],
            filteredNodes: []
        }

    },
    mounted() {
        // We call the learning outcomes class 
        this.learningOutcomes = new LearningOutcomes();

        // We create the current node
        this.curriculummap = new CurriculumMap(this.$route.params.id,this.learningoutcomes);
       

        Promise.all([
            this.curriculummap.getHierarchy(true).then(res => res),
            this.curriculummap.getNodes().then(res => res),
            this.learningOutcomes.list().then(res => res.results),
            this.learningOutcomes.listGroups().then(res => res.results)
        ]).then(([
            hierarchy, nodes, learningoutcomes, outcomesGroups
        ]) => {
            this.hierarchy = hierarchy;
            this.nodes = nodes;
            this.learningoutcomes = learningoutcomes;
            this.outcomesGroups = outcomesGroups;
            if (this.$route.params.action === 'detail') {
                this.selectedNode = hierarchy;
                const original = this.selectedNode.learningoutcomes?.original ? this.selectedNode.learningoutcomes.original : [];
                const linked = this.selectedNode.learningoutcomes?.linked ? this.selectedNode.learningoutcomes.linked : [];

                this.selectedNode.learningoutcomes.original_obj = this.learningoutcomes.filter(obj => original.some(id => id == obj.id)) 
                
                const joint_ids = [
                    ...original,
                    ...linked
                ];

                this.selectedNode.learningoutcomes.joint_obj = this.learningoutcomes.filter(obj => joint_ids.some(id => id == obj.id))
            
            } else {
                this.hierarchy = hierarchy;
            }
            this.loaded = true;
        }).catch((err) => {
            console.error('Error fetching hierarchy or nodes:', err);
            this.loaded = false;
        });

    },
    methods: {
        async exportPNG() {
            const svgEl = this.$refs.dendogram.$el.querySelector('svg');
            if (!svgEl) {
                console.warn('No SVG for PNG export');
                return;
            }

            const clone = svgEl.cloneNode(true);
            const style = document.createElementNS('http://www.w3.org/2000/svg','style');
            style.textContent = `
                .node circle { fill: #ccc !important; stroke: #ccc !important; stroke-width: 2px !important; }
                .link { stroke: green !important; }
                .highlighted circle { fill: red !important; stroke: red !important; stroke-width: 2px !important; }
                text { fill: #000 !important; stroke: none !important; }
            `;
            clone.insertBefore(style, clone.firstChild);

            const width   = svgEl.clientWidth  || svgEl.getBoundingClientRect().width;
            const height  = svgEl.clientHeight || svgEl.getBoundingClientRect().height;
            if (svgEl.getAttribute('viewBox')) {
                clone.setAttribute('viewBox', svgEl.getAttribute('viewBox'));
            }
            clone.setAttribute('width',  width);
            clone.setAttribute('height', height);
            clone.setAttribute('preserveAspectRatio', 'xMidYMid meet');

            const svgData = new XMLSerializer().serializeToString(clone);
            const img     = new Image();
            img.src       = 'data:image/svg+xml;base64,' + btoa(svgData);
            await new Promise(r => img.onload = r);

            const scale        = 3;
            const extraMargin  = Math.round(width * 0.3);
            const headerHeight = 40;                       
            const canvas = document.createElement('canvas');
            canvas.width  = (width + extraMargin) * scale;
            canvas.height = (height + headerHeight) * scale;
            const ctx = canvas.getContext('2d');

            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            ctx.save();
            ctx.scale(scale, scale);
            ctx.fillStyle = '#000';
            ctx.font = 'bold 20px Arial';
            ctx.fillText('CAFS Curriculum Mapping', 10, 25);
            ctx.font = '12px Arial';
            ctx.fillText(`Generated: ${new Date().toLocaleString()}`, 10, 40);
            ctx.restore();

            ctx.scale(scale, scale);
            ctx.drawImage(img, 0, headerHeight, width, height);
            const link = document.createElement('a');
            link.download = 'dendogram.png';
            link.href = canvas.toDataURL('image/png');
            link.click();
        },

        async exportPDF() {
            const svgEl = this.$refs.dendogram.$el.querySelector('svg');
            if (!svgEl) {
                console.warn('No SVG for PDF export');
                return;
            }

            const clone = svgEl.cloneNode(true);
            const style = document.createElementNS('http://www.w3.org/2000/svg','style');
            style.textContent = `
                .node circle { fill: #ccc !important; stroke: #ccc !important; stroke-width: 2px !important; }
                .link { stroke: green !important; }
                .highlighted circle { fill: red !important; stroke: red !important; stroke-width: 2px !important; }
                text { fill: #000 !important; stroke: none !important; }
            `;
            clone.insertBefore(style, clone.firstChild);

            const wrapper = document.createElement('div');
            wrapper.style.visibility = 'hidden';
            wrapper.appendChild(clone);
            document.body.appendChild(wrapper);
            const bbox = clone.getBBox();
            document.body.removeChild(wrapper);

            const pdf   = new jsPDF({ orientation: 'landscape' });
            const pageW = pdf.internal.pageSize.getWidth();
            const pageH = pdf.internal.pageSize.getHeight();
            const headerHeight  = 50; 
            const contentMargin = 80; 

            clone.setAttribute(
            'viewBox',
            `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height + contentMargin}`
            );

            const g = document.createElementNS('http://www.w3.org/2000/svg','g');
            g.setAttribute('transform', `translate(0, ${contentMargin})`);
            Array.from(clone.childNodes)
                .filter(node => node.nodeName !== 'style')
                .forEach(node => g.appendChild(node));
            clone.appendChild(g);

            pdf.setFont('helvetica', 'bold');
            pdf.setFontSize(18);
            pdf.text('CAFS Curriculum Mapping', 10, 15);
            pdf.setFont('helvetica', 'normal');
            pdf.setFontSize(10);
            pdf.text(`Generated: ${new Date().toLocaleString()}`, 10, 24);

            clone.setAttribute('width',  pageW);
            clone.setAttribute('height', pageH - headerHeight);
            clone.setAttribute('preserveAspectRatio', 'xMidYMid meet');

            await pdf.svg(clone, {
            xOffset: 0,
            yOffset: headerHeight
            });

            pdf.save('dendogram.pdf');
        },

        handleSelectedNode(node) {
            this.selectedNode = node;
            // FIX this from API c.f. shortcut ticket 1150
            const original = this.selectedNode.learningoutcomes?.original ? this.selectedNode.learningoutcomes.original : [];
            const linked = this.selectedNode.learningoutcomes?.linked ? this.selectedNode.learningoutcomes.linked : [];

            this.selectedNode.learningoutcomes.original_obj = this.learningoutcomes.filter(obj => original.includes(obj.id)) 
            // Combine both arrays safely
            const joint_ids = [
                ...original,
                ...linked
            ];

            this.selectedNode.learningoutcomes.joint_obj = this.learningoutcomes.filter(obj => joint_ids.includes(obj.id))
            
            this.query = ''
        },
        handleNodeEditor(payload) {
            // Refresh hierarchy
            this.curriculummap.getHierarchy(true).then((res) => {
                // Three possible cases: added, saved and deleted
                
                this.hierarchy = res
                this.$nextTick(() => { this.$refs.dendogram.updateChart();}); 

                const node_to_select = payload.action == 'node_deleted' ? payload.data.parent_id : payload.data.id
                this.$refs.dendogram.highlightNodeAndPath(this.curriculummap.getNode(this.hierarchy, node_to_select))
            })

        },
        highlightLearningOutcome(outcome) {
            // Highlight nodes in the dendogram
            this.$refs.dendogram.highlightMatchingNodes(outcome,
                this.linked_outcomes ? 'learningoutcomes.original' : 'learningoutcomes.original'
            );

            //Set the selectedOutcome so the learning outcome is highlighted
            this.selectedOutcome = outcome;
        },
        resetNode() {
            this.selectedNode = null;
            this.$refs.dendogram.resetPathAndNodes();
        },
        linkedToggle() {
            this.linked_outcomes = !this.linked_outcomes;
            if (this.selectedOutcome) this.highlightLearningOutcome(this.selectedOutcome.id);
        },
        handleFilteredNodes(val) {
            this.filteredNodes = val;
            return val;
        },
 
  
    },
    computed: {
        displayLearningOutcomes() {
            if (this.query || this.selectedOutcomesGroup.id) {
                const query = this.query.toLowerCase();
                return this.learningoutcomes.filter(outcome => {
                    return outcome.title.toLowerCase().includes(query)
                        && (!this.selectedOutcomesGroup.id || outcome.learningoutcomegroup_id === this.selectedOutcomesGroup.id);
                });
            }
            return this.learningoutcomes;
        }
    },
    watch: {
        hierarchy: {
            handler(newVal) {
                if (this.$refs.dendogram && newVal) {
                    this.$refs.dendogram.updateChart(); // Update the chart
                }
            },
            deep: true, 
        },
    }
};
</script>
<style>
.node circle {
    fill: #ccc;
    stroke: #ccc;
    stroke-width: 2px;
}

.node text {
    font-size: 12px;
}

.highlighted circle {
    fill: red;
    stroke: red;
    stroke-width: 2px;
}

.highlighted {
    stroke: red !important;
    stroke-width: 2px;
}

.link {
    stroke: green;
}
.export-controls {
  position: sticky; 
  float: right !important;
  bottom: 100px; 
  left: calc(50px + 50px);    
  z-index: 2000;
  flex-direction: column;
  align-items: flex-start;    
  pointer-events: auto;
}
@media (max-width: 768px) {
  .export-controls {
    display: none !important;
  }
}
.export-controls .btn {
  margin-bottom: 0.5rem;
  white-space: nowrap;
}

</style>
